import { Component, OnInit, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { TreeService } from '@schoolbelle/api/group-to-group';
import { LetterTargetService } from '@schoolbelle/api/letter-target';
import { Subscription } from 'rxjs';
import { GroupMemberService } from '@schoolbelle/api/group-member';
import { Table, Row } from '@schoolbelle/common/table';
import { BoardService } from '@schoolbelle/api/board';

@Component({
  selector: 'admin-or-all',
  templateUrl: './admin-or-all.component.html',
  styleUrls: ['./admin-or-all.component.css'],
  changeDetection:ChangeDetectionStrategy.OnPush,
})
export class SelectLetterTargetsAdminOrAllComponent implements OnInit {
  table = new Table();
  rows:Row[] = [];
  subscription = new Subscription();

  constructor(
    private board:BoardService,
    private letterTarget:LetterTargetService,
  ) { }

  ngOnInit() {


  }
  ngOnDestroy () {
    this.subscription.unsubscribe()
  }

  check (v:'all'|'admin') {
    const group_id = this.board.currentBoard.gid;
    this.letterTarget.unload();
    this.letterTarget.add({group_id, scopes:v === 'all' ? 'studentparent_all':'admin_all' });
    this.letterTarget.refreshTargets();
    this.letterTarget.refreshSimplifiedTargets();
  }
  isChecked (v:'all'|'admin'):boolean {
    const group_id = this.board.currentBoard.gid;
    const scopes = this.letterTarget.getScopes(group_id);
    if (v === 'all') {
      return !scopes.includes('admin_all');
    } else {
      return scopes.includes('admin_all');
    }
  }


}
